const _excluded = ["onSubmit", "titleMP", "subtitleMP"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { TextField, Typography, useIsMounted } from 'seagull';
import { emailValidation } from 'validators';
import { routes } from "../../../../constants";
import { useStoreActions } from "../../../../contexts";
import { handlePromise } from "../../../../infra/utils";
import { useLocationCommonActions } from "../../../../providers/LocationProvider";
import { FormSeparatorHorizontal } from "../../components/FormSeparator";
import { ErrorMessage, FooterLink, FooterText, FormContainer, FormFields, VerticalFormFields, SubmitButtonField } from "../../components/FormComponents";
import GoogleButton from "../../../../components/GoogleButton/GoogleButton";
import { errorMessages } from "../../constants";
import sharedStyles from "../LoginScreen.module.scss";
import IntuitButton from "../../../../components/IntuitButton/IntuitButton";
import { useLocation } from 'react-router';
import TermsAndPrivacyMessage from "../../components/TermsAndPrivacyMessage";
export const loginFlowEndpoint = '/login/flow';
export default function EmailStep(_ref) {
  var _useLocation;
  let {
      onSubmit,
      titleMP,
      subtitleMP
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {
    afterEmailVerification,
    existingEmail
  } = ((_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.state) || {
    afterEmailVerification: false
  };
  const {
    handleSubmit,
    control,
    formState
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: existingEmail || ''
    }
  });
  const {
    api
  } = useStoreActions();
  const isMounted = useIsMounted();
  const {
    getPageUrl
  } = useLocationCommonActions();
  async function onEmailFormSubmit(_ref2) {
    let {
      email
    } = _ref2;
    setErrorMessage(null);
    setIsLoading(true);
    const result = await handlePromise(api.auth.loginEmailStep(email, getPageUrl()));
    if (result.success) {
      const {
        flow
      } = result.data;
      onSubmit({
        email,
        hasPassword: flow === 'password'
      });
    } else {
      setErrorMessage(errorMessages.generalLoginError);
    }
    if (isMounted()) {
      setIsLoading(false);
    }
  }
  return /*#__PURE__*/React.createElement(FormContainer, _extends({}, props, {
    onSubmit: handleSubmit(onEmailFormSubmit)
  }), titleMP, subtitleMP, afterEmailVerification && /*#__PURE__*/React.createElement(Typography, {
    className: sharedStyles.emailVerifiedMsg,
    skin: "success",
    "data-testid": "email-verified-msg"
  }, "Your account has been confirmed"), /*#__PURE__*/React.createElement(FormFields, null, /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "email",
    defaultValue: "",
    rules: emailValidation(undefined, {
      required: true
    }),
    render: _ref3 => {
      var _fieldState$error;
      let {
        field,
        fieldState
      } = _ref3;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, field, {
        type: "email",
        label: "Work email",
        error: fieldState.isTouched && !!fieldState.error,
        helperText: fieldState.isTouched && ((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
        "data-testid": "email-input",
        placeholder: "Work email",
        disabled: isLoading,
        autoComplete: "username"
      }));
    }
  }), /*#__PURE__*/React.createElement(SubmitButtonField, {
    disabled: !formState.isValid,
    isLoading: isLoading,
    "data-testid": "login-button"
  }, "Sign in"), /*#__PURE__*/React.createElement(FormSeparatorHorizontal, null, "Or"), /*#__PURE__*/React.createElement(GoogleButton, {
    testid: "google-btn-sign-in",
    onAuthError: msg => {
      setErrorMessage(msg || errorMessages.generalLoginError);
    }
  }), /*#__PURE__*/React.createElement(IntuitButton, null))), errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "err-message"
  }, errorMessage), /*#__PURE__*/React.createElement("div", {
    className: sharedStyles.footer
  }, /*#__PURE__*/React.createElement(FooterText, null, "No account?", ' ', /*#__PURE__*/React.createElement(FooterLink, {
    toInternalLink: routes.signUp,
    "data-testid": "sign-up-link"
  }, "Sign up for free")), /*#__PURE__*/React.createElement(TermsAndPrivacyMessage, {
    type: "login"
  })));
}